/**
 * caddy feature routes — owned by web-caddy.
 * Add child routes here (this file and everything under features/caddy/ belong to the owner).
 * The pathless "caddyFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';
// eager: capture Chrome's one-shot beforeinstallprompt before the lazy caddy pages mount
import './lib/install';

export const caddyFeature = createRoute({ getParentRoute: () => rootRoute, id: 'caddy' });

export const caddyLoginRoute = createRoute({
  getParentRoute: () => caddyFeature,
  path: '/c/$caddyToken',
  component: lazyRouteComponent(() => import('./pages/CaddyLoginPage'), 'CaddyLoginPage'),
});

export const caddyAppRoute = createRoute({
  getParentRoute: () => caddyFeature,
  path: '/caddy',
  component: lazyRouteComponent(() => import('./pages/CaddyAppPage'), 'CaddyAppPage'),
});

export const caddyRouteTree = caddyFeature.addChildren([caddyLoginRoute, caddyAppRoute]);
